import { RouteRecordRaw } from "vue-router";

export const routes: Array<RouteRecordRaw> = [
  {
    path: "call-tracking/phone-numbers",
    name: "call-tracking-phone-numbers",
    component: () =>
      import("./views/trackingPhoneNumbers/trackingPhoneNumbers.vue"),
  },
  {
    path: "call-tracking/destination-numbers",
    name: "call-tracking-destination-phone-numbers",
    component: () =>
      import("./views/destinationNumbers/destinationNumbers.vue"),
  },
  {
    path: "call-tracking/pools",
    name: "call-tracking-pools",
    component: () => import("./views/trackingPools/trackingPools.vue"),
  },
];
